import React, { useState } from 'react';
import { Form, Message } from 'semantic-ui-react';
import { useNavigate } from 'react-router';
import { useUsers } from '../../../providers/UsersProvider';
import {useAuth} from "../../../providers/AuthenticationProvider";
const WEB_PAGE = 'Users';

export const ChangePassword = () => {
    const { checkAuth, getUserType } = useAuth();
    const [currentPassword, setCurrentPassword] = useState();
    const [newPassword, setNewPassword] = useState();
    const [newPasswordConfirm, setNewPasswordConfirm] = useState();
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const { changePassword } = useUsers();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    const handleSubmit = async () => {
        try {
            if (newPassword !== newPasswordConfirm) {
                setErrors(["New Password and New Password Confirmation do not match"]);
                return;
            }

            setSuccess(false);
            setLoading(true);

            await changePassword(currentPassword, newPassword, newPasswordConfirm);

            setErrors([]);
            setSuccess(true);
            setCurrentPassword('');
            setNewPassword('');
            setNewPasswordConfirm('');
        } catch (err) {
            setErrors(err?.response?.data?.errors.map(error => {
                return error;
            }));
        }
        setLoading(false);
    };

    return (
        <div>
            <div className="pageHeader">
                <h1>Change Password</h1>
            </div>

            <Form onSubmit={handleSubmit} error={errors.length > 0} style={{ maxWidth: '450px' }}>
                <Form.Group>
                    <Form.Input
                        width={16}
                        label="Current Password"
                        onChange={e => {
                            setCurrentPassword(e.target.value);
                        }}
                        type="password"
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Input
                        width={16}
                        label="New Password"
                        onChange={e => {
                            setNewPassword(e.target.value);
                        }}
                        type="password"
                        autoComplete="new-password"
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Input
                        width={16}
                        label="Confirm New Password"
                        onChange={e => {
                            setNewPasswordConfirm(e.target.value);
                        }}
                        type="password"
                        autoComplete="new-password"
                        required
                    />
                </Form.Group>
                <Form.Group width={6}>
                    <Form.Button size={'large'} style={{ marginTop: '32px' }} type={'submit'} loading={loading} color={'blue'} disabled={success}>
                        Submit
                    </Form.Button>
                    <Form.Button
                        size={'large'}
                        style={{ marginTop: '32px' }}
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                        }}
                    >
                        {(success) ? 'Go Back' : 'Cancel'}
                    </Form.Button>
                </Form.Group>
                {errors.length > 0 ? (
                    <Form.Group widths={2}>
                        <Message color="red" list={errors} />
                    </Form.Group>
                ) : null}
                {success ? (
                    <Form.Group widths={2}>
                        <Message color="green" content="Password changed successfully" />
                    </Form.Group>
                ) : null}
            </Form>
        </div>
    );
};
